/* eslint-disable */
// @ts-nocheck

import { AlertTriangleIcon, UploadIcon } from 'lucide-react'

import OrderStatusBadge from '@/components/misc/badges/OrderStatusBadge'
import { TableColumn } from '@/components/new/table/DataTable'
import { IExpedient } from '@/containers/logistic/expedients/interfaces/interfaces'
import { ICost } from '@/containers/logistic/expedients/wizzardExpedient/tabs/cost/interfaces'
import { IDocumentTable } from '@/containers/logistic/expedients/wizzardExpedient/tabs/document/interfaces'
import { formatDateForTable } from '@/utils/helpers'

export const columns: TableColumn<any>[] = [
  {
    accessorKey: 'type',
    header: 'Tipo',
    cell: ({ row }) => {
      const typeLabels = {
        SUPPLIER: 'Proveedor',
        OPERATIONAL: 'Operacional',
        INDIRECT: 'Indirecto',
        UNDEFINED: 'Indefinido',
      }
      return (
        <p className={'py-1 font-medium'}>
          {typeLabels[row.original.type as keyof typeof typeLabels] ||
            row.original.type ||
            '-'}
        </p>
      )
    },
  },
  {
    accessorKey: 'price',
    header: 'Monto',
    cell: ({ row }) => {
      const price = row.original.price
      return (
        <p className={'py-1 font-medium'}>
          {price ? `${price.amount} ${price.codeCurrency}` : '-'}
        </p>
      )
    },
  },
  {
    accessorKey: 'codeCurrency',
    header: 'Moneda',
    cell: ({ row }) => {
      return (
        <p className={'py-1 font-medium'}>
          {row.original.price?.codeCurrency || '-'}
        </p>
      )
    },
  },
]
